import styled from 'styled-components';

export const StyledTopSection = styled.section`
  position: relative;
  padding: 2.5rem 0;
  background-color: ${(props) => props.theme.globalStyle.bgd};
  background-size: auto auto;
  background-image: ${(props) => props.theme.globalStyle.stripedBgd};
  height: 100%;

  & {
    .service-name {
      font-size: ${(props) => props.theme.fontSizes.h3.fontSize};
    }

    .content-wrapper {
      margin-top: 2.5rem;
      display: grid;
      justify-content: center;
      row-gap: 1.25rem;
    }

    .content-text {
      margin-top: 2.5rem;
      font-size: ${(props) => props.theme.fontSizes.text.fontSize};
      line-height: 1.5;
    }
  }

  ${({ theme }) => theme.mediaQueries.min.md} {
    padding: 3.75rem 0 4.75rem;

    & {
      .service-name {
        font-size: 2.5rem;
      }

      .content-text {
        margin-top: 3.75rem;
        font-size: ${(props) => props.theme.fontSizes.h4.fontSize};
      }
    }
  }

  ${({ theme }) => theme.mediaQueries.min.lg} {
    & {
      .service-name {
        font-size: 4rem;
      }
    }
  }
`;
